export default __webpack_public_path__ + "static/media/computer.f6544984.png";